import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from "@radix-ui/react-collapsible";
import {
    ArchiveRestoreIcon,
    BaggageClaim,
    BookTemplateIcon,
    Boxes,
    BriefcaseBusinessIcon,
    ChartSplineIcon,
    ChevronRight,
    CircleArrowOutUpRight,
    CircleCheckBig,
    ClipboardClockIcon,
    Cog,
    Files,
    FileStackIcon,
    Handshake,
    IdCardLanyardIcon,
    Lightbulb,
    Pickaxe,
    Receipt,
    ReceiptTextIcon,
    ScrollTextIcon,
    ShieldCheckIcon,
    UserCheckIcon,
    Users,
    UserStarIcon,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import { Button } from "../../components/ui/button";
import hasAnyPermission from "@/lib/hasAnyPermission";
import { modules, permissions } from "@/lib/permissions";
import checkCondition from "@/lib/checkCondition";
import { useAppSelector } from "../hooks/hooks";

const topMenus = [
    {
        module: modules.PROJECT_MANAGEMENT,
        title: "Projects",
        url: "/projects",
        icon: BriefcaseBusinessIcon,
        permissions: [
            ...permissions.ALL_PROJECT_MANAGEMENT,
            ...permissions.READ_PROJECT_MANAGEMENT,
            ...permissions.CREATE_PROJECT_MANAGEMENT,
            ...permissions.UPDATE_PROJECT_MANAGEMENT,
            ...permissions.DELETE_PROJECT_MANAGEMENT,
        ],
    },
    {
        module: modules.MOBILIZATION_MANAGEMENT,
        title: "Mobilization Database",
        url: "/mobilization-database",
        icon: Boxes,
        permissions: [
            ...permissions.ALL_MOBILIZATION_MANAGEMENT,
            ...permissions.READ_MOBILIZATION_MANAGEMENT,
            ...permissions.CREATE_MOBILIZATION_MANAGEMENT,
            ...permissions.UPDATE_MOBILIZATION_MANAGEMENT,
            ...permissions.DELETE_MOBILIZATION_MANAGEMENT,
        ],
    },

    {
        module: modules.SUPPLIER_MANAGEMENT,
        title: "Supplier Database",
        url: "/supplier-database",
        icon: BaggageClaim,
        permissions: [
            ...permissions.ALL_SUPPLIER_MANAGEMENT,
            ...permissions.READ_SUPPLIER_MANAGEMENT,
            ...permissions.CREATE_SUPPLIER_MANAGEMENT,
            ...permissions.DELETE_SUPPLIER_MANAGEMENT,
            ...permissions.UPDATE_SUPPLIER_MANAGEMENT,
        ],
    },
    {
        module: modules.CLIENT_MANAGEMENT,
        title: "Client Database",
        url: "/client-database",
        icon: Handshake,
        permissions: [
            ...permissions.ALL_CLIENT_MANAGEMENT,
            ...permissions.READ_CLIENT_MANAGEMENT,
            ...permissions.CREATE_CLIENT_MANAGEMENT,
            ...permissions.DELETE_CLIENT_MANAGEMENT,
            ...permissions.UPDATE_CLIENT_MANAGEMENT,
        ],
    },
    {
        module: modules.EMPLOYEE_MANAGEMENT,
        title: "Employee Database",
        url: "/employee-database",
        icon: Pickaxe,
        permissions: [
            ...permissions.ALL_EMPLOYEE_MANAGEMENT,
            ...permissions.READ_EMPLOYEE_MANAGEMENT,
            ...permissions.CREATE_EMPLOYEE_MANAGEMENT,
            ...permissions.UPDATE_EMPLOYEE_MANAGEMENT,
            ...permissions.DELETE_EMPLOYEE_MANAGEMENT,
        ],
    },
    {
        module: modules.EMPLOYEE_MANAGEMENT,
        title: "AR Office Staffs",
        url: "/ar-employee-database",
        icon: IdCardLanyardIcon,
        permissions: [
            ...permissions.ALL_EMPLOYEE_MANAGEMENT,
            ...permissions.READ_EMPLOYEE_MANAGEMENT,
            ...permissions.CREATE_EMPLOYEE_MANAGEMENT,
            ...permissions.UPDATE_EMPLOYEE_MANAGEMENT,
            ...permissions.DELETE_EMPLOYEE_MANAGEMENT,
        ],
    },
    {
        module: modules.PERSONAL_TRACKING_MANAGEMENT,
        title: "Performance Dashboard",
        url: "/performance-tracker",
        icon: UserStarIcon,
        permissions: [
            ...permissions.ALL_PERSONAL_TRACKING_MANAGEMENT,
            ...permissions.READ_PERSONAL_TRACKING_MANAGEMENT,
            ...permissions.CREATE_PERSONAL_TRACKING_MANAGEMENT,
            ...permissions.UPDATE_PERSONAL_TRACKING_MANAGEMENT,
            ...permissions.DELETE_PERSONAL_TRACKING_MANAGEMENT,
        ],
    },
    {
        module: modules.SALES_ENQUIRY_MANAGEMENT,
        title: "Sales Enquiry",
        url: "/sales-enquiry",
        icon: BaggageClaim,
        permissions: [
            ...permissions.ALL_SALES_ENQUIRY_MANAGEMENT,
            ...permissions.READ_SALES_ENQUIRY_MANAGEMENT,
            ...permissions.CREATE_SALES_ENQUIRY_MANAGEMENT,
            ...permissions.UPDATE_SALES_ENQUIRY_MANAGEMENT,
            ...permissions.DELETE_SALES_ENQUIRY_MANAGEMENT,
        ],
    },
    {
        module: modules.SERVICE_AGREEMENT_MANAGEMENT,
        title: "Servcie Agreement",
        url: "/service-agreement",
        icon: FileStackIcon,
        permissions: [
            ...permissions.ALL_SERVICE_AGREEMENT_MANAGEMENT,
            ...permissions.READ_SERVICE_AGREEMENT_MANAGEMENT,
            ...permissions.CREATE_SERVICE_AGREEMENT_MANAGEMENT,
            ...permissions.UPDATE_SERVICE_AGREEMENT_MANAGEMENT,
            ...permissions.DELETE_SERVICE_AGREEMENT_MANAGEMENT,
        ],
    },
    {
        module: modules.ASSET_MANAGEMENT,
        title: "Assets",
        url: "/assets",
        icon: ArchiveRestoreIcon,
        permissions: [
            ...permissions.ALL_ASSET_MANAGEMENT,
            ...permissions.READ_ASSET_MANAGEMENT,
            ...permissions.CREATE_ASSET_MANAGEMENT,
            ...permissions.UPDATE_ASSET_MANAGEMENT,
            ...permissions.DELETE_ASSET_MANAGEMENT,
        ],
    },
    {
        module: modules.TIMESHEET_MANAGEMENT,
        title: "Time Sheet",
        url: "/time-sheet",
        icon: ClipboardClockIcon,
        permissions: [
            ...permissions.ALL_TIMESHEET_MANAGEMENT,
            ...permissions.READ_TIMESHEET_MANAGEMENT,
            ...permissions.CREATE_TIMESHEET_MANAGEMENT,
            ...permissions.UPDATE_TIMESHEET_MANAGEMENT,
            ...permissions.DELETE_TIMESHEET_MANAGEMENT,
        ],
    },
    {
        module: modules.QUOTATION_MANAGEMENT,
        title: "Quotation",
        url: "/quotation",
        icon: ScrollTextIcon,
        permissions: [
            ...permissions.ALL_QUOTATION_MANAGEMENT,
            ...permissions.READ_QUOTATION_MANAGEMENT,
            ...permissions.CREATE_QUOTATION_MANAGEMENT,
            ...permissions.UPDATE_QUOTATION_MANAGEMENT,
            ...permissions.DELETE_QUOTATION_MANAGEMENT,
        ],
    },
];

const issuedPOmenus = [
    {
        title: "Manpower P.O",
        url: "/manpower-purchase-order",
        icon: Users,
    },
    {
        title: "Equipments P.O",
        url: "/equipments-purchase-order",
        icon: Cog,
    },
    {
        title: "Project P.O",
        url: "/project-purchase-order",
        icon: Lightbulb,
    },
];

const invoiceTrackerMenu = [
    {
        title: "Payable Invoice",
        url: "/payable-invoice",
        icon: Users,
    },
    {
        title: "Receivable Invoice",
        url: "/receivable-invoice",
        icon: Cog,
    },
];

const approvalMenu = [
    {
        title: "Approve Suppliers",
        url: "/supplier",
        icon: UserCheckIcon,
    },
];

const templatesMenu = [
    {
        title: "Terms and Conditions",
        url: "/terms-and-conditions",
        icon: ReceiptTextIcon,
    },
];

export default function NavMain() {
    const user = useAppSelector((state) => state.user.value);
    return (
        <>
            <NavLink
                to={"/"}
                className={({ isActive }) =>
                    isActive
                        ? "rounded-md bg-blue-100 text-black"
                        : "hover:bg-accent hover:text-accent-foreground"
                }
            >
                <div className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground">
                    <ChartSplineIcon className="h-4 w-4 shrink-0" />
                    <div className="flex flex-1 overflow-hidden">
                        <div className="line-clamp-1 pr-6">Dashboard</div>
                    </div>
                </div>
            </NavLink>

            {topMenus.map((menu) => {
                if (
                    menu.url === "/performance-tracker" &&
                    user?.roles?.some(
                        (r) => r.handle === "BUSINESS_DEVELOPMENT_MANAGER",
                    )
                ) {
                    return null;
                }

                if (
                    menu.url === "/ar-employee-database" &&
                    user?.roles?.some(
                        (r) => r.handle === "BUSINESS_COORDINATORS",
                    )
                ) {
                    return null;
                }

                if (
                    hasAnyPermission(user, {
                        module: menu.module,
                        scope: menu.permissions,
                    })
                ) {
                    return (
                        <NavLink
                            key={menu.url}
                            to={menu.url}
                            className={({ isActive }) =>
                                isActive
                                    ? "rounded-md bg-blue-100 text-black"
                                    : "hover:bg-accent hover:text-accent-foreground"
                            }
                        >
                            <div className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground">
                                <menu.icon className="h-4 w-4 shrink-0" />
                                <div className="flex flex-1 overflow-hidden">
                                    <div className="line-clamp-1 pr-6">
                                        {menu.title}
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    );
                }
            })}

            {hasAnyPermission(user, {
                module: modules.PURCHASE_ORDER_MANAGEMENT,
                scope: permissions.ALL_PURCHASE_ORDER_MANAGEMENT,
            }) && (
                <Collapsible asChild defaultOpen={true}>
                    <div>
                        <div className="relative flex items-center">
                            <CollapsibleTrigger asChild>
                                <span className="flex h-8 min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all hover:bg-accent hover:text-accent-foreground focus-visible:ring-2">
                                    <CircleArrowOutUpRight className="h-4 w-4 shrink-0" />
                                    <div className="flex flex-1 overflow-hidden">
                                        <div className="line-clamp-1 pr-6">
                                            Issued P.O
                                        </div>
                                    </div>
                                </span>
                            </CollapsibleTrigger>
                            <CollapsibleTrigger asChild>
                                <Button
                                    variant="ghost"
                                    className="absolute right-2 h-6 w-6 rounded-md p-0 ring-ring transition-all focus-visible:ring-2 data-[state=open]:rotate-90"
                                >
                                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                                    <span className="sr-only">Toggle</span>
                                </Button>
                            </CollapsibleTrigger>
                        </div>
                        <CollapsibleContent className="px-4 py-0.5">
                            <ul className="grid gap-2 border-l px-2">
                                {issuedPOmenus.map((menu, index) => (
                                    <NavLink
                                        key={menu.url}
                                        to={"/issued-purchase-order" + menu.url}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "rounded-md bg-blue-100 text-black"
                                                : "hover:bg-accent hover:text-accent-foreground"
                                        }
                                    >
                                        <li
                                            key={index}
                                            className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground"
                                        >
                                            <menu.icon className="h-4 w-4 shrink-0" />
                                            <div className="line-clamp-1">
                                                {menu.title}
                                            </div>
                                        </li>
                                    </NavLink>
                                ))}
                            </ul>
                        </CollapsibleContent>
                    </div>
                </Collapsible>
            )}

            {hasAnyPermission(user, {
                module: modules.PURCHASE_ORDER_MANAGEMENT,
                scope: permissions.ALL_PURCHASE_ORDER_MANAGEMENT,
            }) &&
                checkCondition(user, {
                    module: modules.PURCHASE_ORDER_MANAGEMENT,
                    value: "RECEIVED",
                    operator: "eq",
                    field: "status",
                }) && (
                    <NavLink
                        to={"/received-purchase-order"}
                        className={({ isActive }) =>
                            isActive
                                ? "rounded-md bg-blue-100 text-black"
                                : "hover:bg-accent hover:text-accent-foreground"
                        }
                    >
                        <div className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all hover:bg-accent hover:text-accent-foreground focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground">
                            <CircleCheckBig className="h-4 w-4 shrink-0" />
                            <div className="flex flex-1 overflow-hidden">
                                <div className="line-clamp-1 pr-6">
                                    Received P.O
                                </div>
                            </div>
                        </div>
                    </NavLink>
                )}

            {hasAnyPermission(user, {
                module: modules.INVOICE_MANAGEMENT,
                scope: [...permissions.ALL_INVOICE_MANAGEMENT],
            }) && (
                <Collapsible asChild defaultOpen={true}>
                    <div>
                        <div className="relative flex items-center">
                            <CollapsibleTrigger asChild>
                                <span className="flex h-8 min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all hover:bg-accent hover:text-accent-foreground focus-visible:ring-2">
                                    <Receipt className="h-4 w-4 shrink-0" />
                                    <div className="flex flex-1 overflow-hidden">
                                        <div className="line-clamp-1 pr-6">
                                            Invoice Tracker
                                        </div>
                                    </div>
                                </span>
                            </CollapsibleTrigger>
                            <CollapsibleTrigger asChild>
                                <Button
                                    variant="ghost"
                                    className="absolute right-2 h-6 w-6 rounded-md p-0 ring-ring transition-all focus-visible:ring-2 data-[state=open]:rotate-90"
                                >
                                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                                    <span className="sr-only">Toggle</span>
                                </Button>
                            </CollapsibleTrigger>
                        </div>
                        <CollapsibleContent className="px-4 py-0.5">
                            <ul className="grid gap-2 border-l px-2">
                                {invoiceTrackerMenu.map((menu, index) => (
                                    <NavLink
                                        key={menu.url}
                                        to={"/invoice-tracker" + menu.url}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "rounded-md bg-blue-100 text-black"
                                                : "hover:bg-accent hover:text-accent-foreground"
                                        }
                                    >
                                        <li
                                            key={index}
                                            className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground"
                                        >
                                            <menu.icon className="h-4 w-4 shrink-0" />
                                            <div className="line-clamp-1">
                                                {menu.title}
                                            </div>
                                        </li>
                                    </NavLink>
                                ))}
                            </ul>
                        </CollapsibleContent>
                    </div>
                </Collapsible>
            )}

            {hasAnyPermission(user, {
                module: modules.SUPPLIER_MANAGEMENT,
                scope: [...permissions.UPDATE_SUPPLIER_MANAGEMENT],
            }) && (
                <Collapsible asChild defaultOpen={true}>
                    <div>
                        <div className="relative flex items-center">
                            <CollapsibleTrigger asChild>
                                <span className="flex h-8 min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all hover:bg-accent hover:text-accent-foreground focus-visible:ring-2">
                                    <ShieldCheckIcon className="h-4 w-4 shrink-0" />
                                    <div className="flex flex-1 overflow-hidden">
                                        <div className="line-clamp-1 pr-6">
                                            Approve
                                        </div>
                                    </div>
                                </span>
                            </CollapsibleTrigger>
                            <CollapsibleTrigger asChild>
                                <Button
                                    variant="ghost"
                                    className="absolute right-2 h-6 w-6 rounded-md p-0 ring-ring transition-all focus-visible:ring-2 data-[state=open]:rotate-90"
                                >
                                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                                    <span className="sr-only">Toggle</span>
                                </Button>
                            </CollapsibleTrigger>
                        </div>
                        <CollapsibleContent className="px-4 py-0.5">
                            <ul className="grid gap-2 border-l px-2">
                                {approvalMenu.map((menu, index) => (
                                    <NavLink
                                        key={menu.url}
                                        to={"/approve" + menu.url}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "rounded-md bg-blue-100 text-black"
                                                : "hover:bg-accent hover:text-accent-foreground"
                                        }
                                    >
                                        <li
                                            key={index}
                                            className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground"
                                        >
                                            <menu.icon className="h-4 w-4 shrink-0" />
                                            <div className="line-clamp-1">
                                                {menu.title}
                                            </div>
                                        </li>
                                    </NavLink>
                                ))}
                            </ul>
                        </CollapsibleContent>
                    </div>
                </Collapsible>
            )}

            {hasAnyPermission(user, {
                module: modules.SUPPLIER_MANAGEMENT,
                scope: [...permissions.UPDATE_SUPPLIER_MANAGEMENT],
            }) && (
                <Collapsible asChild defaultOpen={true}>
                    <div>
                        <div className="relative flex items-center">
                            <CollapsibleTrigger asChild>
                                <span className="flex h-8 min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all hover:bg-accent hover:text-accent-foreground focus-visible:ring-2">
                                    <BookTemplateIcon className="h-4 w-4 shrink-0" />
                                    <div className="flex flex-1 overflow-hidden">
                                        <div className="line-clamp-1 pr-6">
                                            Templates
                                        </div>
                                    </div>
                                </span>
                            </CollapsibleTrigger>
                            <CollapsibleTrigger asChild>
                                <Button
                                    variant="ghost"
                                    className="absolute right-2 h-6 w-6 rounded-md p-0 ring-ring transition-all focus-visible:ring-2 data-[state=open]:rotate-90"
                                >
                                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                                    <span className="sr-only">Toggle</span>
                                </Button>
                            </CollapsibleTrigger>
                        </div>
                        <CollapsibleContent className="px-4 py-0.5">
                            <ul className="grid gap-2 border-l px-2">
                                {templatesMenu.map((menu, index) => (
                                    <NavLink
                                        key={menu.url}
                                        to={"/templates" + menu.url}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "rounded-md bg-blue-100 text-black"
                                                : "hover:bg-accent hover:text-accent-foreground"
                                        }
                                    >
                                        <li
                                            key={index}
                                            className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground"
                                        >
                                            <menu.icon className="h-4 w-4 shrink-0" />
                                            <div className="line-clamp-1">
                                                {menu.title}
                                            </div>
                                        </li>
                                    </NavLink>
                                ))}
                            </ul>
                        </CollapsibleContent>
                    </div>
                </Collapsible>
            )}

            {hasAnyPermission(user, {
                module: modules.DOCUMENT_MANAGEMENT,
                scope: [...permissions.ALL_DOCUMENT_MANAGEMENT],
            }) && (
                <NavLink
                    to={"/company-documents"}
                    className={({ isActive }) =>
                        isActive
                            ? "rounded-md bg-blue-100 text-black"
                            : "hover:bg-accent hover:text-accent-foreground"
                    }
                >
                    <div className="flex h-8 w-full min-w-8 flex-1 items-center gap-2 overflow-hidden rounded-md px-1.5 text-sm font-medium outline-none ring-ring transition-all hover:bg-accent hover:text-accent-foreground focus-visible:ring-2 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground">
                        <Files className="h-4 w-4 shrink-0" />
                        <div className="flex flex-1 overflow-hidden">
                            <div className="line-clamp-1 pr-6">
                                Company Documents
                            </div>
                        </div>
                    </div>
                </NavLink>
            )}
        </>
    );
}
